export const PublishTools = {
  flow: 'y',
  gap: 'A',
  margin: '- -Z2',
  childExtends: 'DomainItem',
  Custom: {
    Hgroup: {
      H: {
        text: 'Version 2.0.0'
      },
      P: {
        text: '{{ publish.tools.updateMajor | polyglot }}'
      }
    }
  },
  Lookup: {
    Icon: {
      name: 'sf search'
    },
    Hgroup: {
      H: {
        text: 'Version 1.2.0'
      },
      P: {
        text: '{{ publish.tools.updateMinor | polyglot }}'
      }
    }
  },
  Current: {
    Icon: null,
    Hgroup: {
      H: {
        text: (el) => 'Version ' + el.getRootState('version'),
        IconButton: {
          extends: ['CanvasButton', 'IconButton'],
          theme: null,
          padding: 'Y',
          margin: '- - -Z X',
          icon: 'search oval dotted',
          aria: { label: (el) => el.call('polyglot', 'publish.tools.showVersions') },
          onClick: (ev, el, s) => {
            el.getRootState().toggle('isVersionsOpen', {
              preventUpdate: true
            })
            el.getVersionsAside()?.update()
          }
        }
      },
      P: {
        text: '{{ publish.tools.autosaved | polyglot }}'
      }
    },
    Upgrade: null,
    Span: {
      margin: '- - - auto',
      text: '{{ publish.tools.latest | polyglot }}'
    }
  }
}
